import React from 'react';
import { useIdentificationContext } from '@fiverr-private/identification_core';
import { Container, Stack } from '@fiverr-private/layout_components';
import { theme } from '@fiverr-private/theme';
import { OnboardingHeader } from '../OnboardingHeader';
import { ActiveStep } from '../ActiveStep';

export const IdentificationContent = () => {
    const { variant } = useIdentificationContext();

    if (variant === 'onboarding') {
        return (
            <Stack gap="0" direction="column" margin="auto" width="100%" height="100%">
                <OnboardingHeader />
                <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    flexGrow={1}
                    paddingY={{ default: '6', sm: '8', md: '12' }}
                    paddingLeft={{ default: '6', sm: '8', md: '32', lg: '16' }}
                    paddingRight={{ default: '6', sm: '8', md: '32', lg: '10' }}
                    maxWidth={theme.numericBreakpoints.xl}
                    width="100%"
                    margin="auto"
                    overflowY="auto"
                    maxHeight="100%"
                >
                    <Container maxHeight="100%" height="100%" width="100%">
                        <ActiveStep />
                    </Container>
                </Stack>
            </Stack>
        );
    }

    return (
        <Container overflow="auto" height={{ default: '100%', sm: '645px' }} width="100%">
            <ActiveStep />
        </Container>
    );
};
